import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import * as React from 'react';
import SkvelkoBox from '../AudienceIntro/SkvelkoBox';
import { loadSkvelkoCities } from '../Home/actions';
import { Media, MediaContextProvider } from '../../theme/media';
import styled from 'styled-components';
import { rem } from 'polished';

interface SkvelkoSearchBoxProps {
  user: any;
  dispatch: any;
  params?: {
    id?: string;
  };
  settings: any;
  redirectOnSearch?: boolean;
}

const SkvelkoSearchBox = (props: SkvelkoSearchBoxProps) => {
  return (
    <MediaContextProvider>
      <Media greaterThanOrEqual="lg">
        <FilterWrapper>
          <BoxColumn>
            <SkvelkoBox />
          </BoxColumn>
          {/* Gifts banner disabled for now (by request). When restoring, put
              hideGirl={giftValid} back on the SkvelkoBox above — the girl
              would overlap the intro text in the card narrowed by the banner.
              Also reinstate the removed helpers (+ their imports:
              GiftsBanner/GiftsBannerMobile, setArticleModal, getGift* and
              isCartGiftsValid from utilities):
                const onGiftOpen = async () => {
                  props.dispatch(
                    setArticleModal(getGiftWebContentIdFromSettings(props.settings)),
                  );
                };
                const giftValid = isCartGiftsValid(props.settings, props.user);
          {giftValid ? (
            <GiftsBanner
              bannerUrl={getGiftSetsDesktopBannerFromSettings(props.settings)}
              onLinkClick={onGiftOpen}
            />
          ) : (
            <></>
          )}
          */}
        </FilterWrapper>
      </Media>
      <Media lessThan="lg">
        {/* Mobile counterpart of the disabled gifts banner.
        {giftValid ? <GiftsBannerMobile onLinkClick={onGiftOpen} /> : <></>}
        */}

        <SkvelkoBox />
      </Media>
    </MediaContextProvider>
  );
};

SkvelkoSearchBox.getInitialProps = async (props) => {
  const promises: any[] = [];
  if (!props.skvelkoCities || !props.skvelkoCities.length) {
    promises.push(props.dispatch(loadSkvelkoCities()));
  }
  await Promise.all(promises);
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    skvelkoCities: state.home.skvelkoCities,
    settings: state.general.settings,
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'SkvelkoSearchBox' })(SkvelkoSearchBox),
);

const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 ${rem(5)};
`;

const BoxColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;
